module.exports = __webpack_public_path__ + "static/media/logo-transparent-kopie.2c5ea922.png";